// @ts-nocheck
/* eslint-disable unicorn/no-array-push-push */
import _ from 'lodash-es';
import Defaults from '~/scripts/constants/defaults';
import { COMPOSED_OF } from '~/scripts/constants/common-kids';
import { ConfirmDeleteModal } from '~/utils/modals';
import Utils from '~/scripts/services/utils';
import mfSelectModalComponent from '~/components/ktable/modals/mf-select/mf-select-modal.component';
import selectIsaModalComponent from './modals/select-isa/select-isa-modal.component';
import APIV5 from '~/models/api';
import Form from '~/scripts/services/model/form';
import Repre from '~/scripts/services/model/repre';

/* globals Knitiv */

/**
 * @typedef CardGridOptionsActions
 * @property {boolean} delete
 * @property {boolean} insertCreate
 * @property {boolean} insertExisting
 * @property {boolean} refresh
 * @property {boolean} search
 * @property {boolean} upload
 */

/**
 * @typedef CardGridOptionsDisplay
 * @property {boolean} status
 */

/**
 * @typedef CardGridOptionsDescendants
 * @property {boolean} enabled
 * @property {import('@knitiv/api-client-javascript').KNode} isa
 * @property {import('@knitiv/api-client-javascript').KNode} kid
 * @property {string} name
 * @property {import('@knitiv/api-client-javascript').TypeKid} name_type_kid
 * @property {boolean} orphan
 */

/**
 * @typedef CardGridOptions
 * @property {CardGridOptionsActions} actions
 * @property {CardGridOptionsDescendants} descendants
 * @property {CardGridOptionsDisplay} display
 * @property {{
 *   kid: import('@knitiv/api-client-javascript').KNode,
 *   key: string,
 * }} parent
 */

const ul = s => s.normalize('NFKD').replaceAll(/[\u0300-\u036F]/g, '').toLowerCase() || '';

export default class CardGridController {
	/* @ngInject */
	/**
	 * @param {import('angular').IRootElementService} $element Angular $element service
	 * @param {import('angular').ICompileService} $compile Angular $compile service
	 * @param {any} $copyToClipboard $copyToClipboard service
	 * @param {import('angular').IFilterService} $filter Angular $filter service
	 * @param {import('angular').auto.IInjectorService} $injector Angular $injector service
	 * @param {import('angular').IQService} $q Angular $q service
	 * @param {Knitiv.RootScope} $rootScope Angular $rootscope service
	 * @param {import('angular').IScope} $scope Angular $scope service
	 * @param {import('angular').ITimeoutService} $timeout Angular $timeout service
	 * @param {import('angular').translate.ITranslateService} $translate Angular $rootscope service
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal Angular $uibModal service
	 * @param {import('~/scripts/services/form.service').default} FormService FileDownloadService service
	 * @param {any} FileDownloadService FileDownloadService service
	 * @param {any} NodeService Node service
	 * @param {any} Notification Notification service
	 * @param {any} User
	 */
	constructor(
		$element,
		$compile,
		$copyToClipboard,
		$filter,
		$injector,
		$q,
		$rootScope,
		$scope,
		$timeout,
		$translate,
		$uibModal,
		FormService,
		FileDownloadService,
		NodeService,
		Notification,
		User,
	) {
		this.$compile = $compile;
		this.$copyToClipboard = $copyToClipboard;
		this.$element = $element;
		this.$filter = $filter;
		this.$injector = $injector;
		this.$q = $q;
		this.$rootScope = $rootScope;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.$uibModal = $uibModal;
		this.FormService = FormService;
		this.FileDownloadService = FileDownloadService;
		this.NodeService = NodeService;
		this.Notification = Notification;
		this.User = User;

		this.cardGridValidate = {};

		/** @type {any} */
		this.component = undefined;

		/** @type {CardGridOptions} */
		this.defaultOptions = {
			actions: {
				insertCreate:   true,
				insertExisting: true,
				refresh:        true,
				upload:         true,
			},
			display: {
				status: true,
			},
			parent:  {},
		};

		/** @type {any[]} */
		this.descendants = [];

		/** @type {boolean} */
		this.disabled = false;

		/** @type {boolean} */
		this.exporting = false;

		/** @type {{search: any}} */
		this.filters = {
			search: undefined,
		};

		/** @type {?import('~/components/kform/kform.controller').default} */
		this.kformCtrl = null;

		/** @type {(import('~/scripts/services/model/form').default | any)[]} */
		this.items = [];

		/** @type {boolean} */
		this.loading = false;

		/** @type {?import('angular').INgModelController} */
		this.ngModelCtrl = null;

		/** @type {CardGridOptions} */
		this.options = { ...this.defaultOptions };

		/** @type {number} */
		this.packet_index = 1;

		/** @type {number} */
		this.packet_size = 50;

		this.search = '';
	}

	/**
	 * @param {import('@knitiv/api-client-javascript').KNodeOptional} isa
	 * @param {any} file
	 */
	async add(isa, file) {
		const parent = _.merge({
			key: this.component?.key,
		}, this.options.parent);
		const formClass = {
			isa,
			cardGridController: this,
			file,
		};
		if (parent?.kid) {
			parent.target = {
				class_kid: this.options.parent.isa.objid,
				linker_kid: '0',
				relation_kid: COMPOSED_OF,
			};
			if (this.kformCtrl?.options.readOnly) {
				await this.kformCtrl.edit();
			}

			const options = {
				items: this.FormService.getItemsForSave(this.kformCtrl.forms, this.kformCtrl.submissions),
			};

			await this.kformCtrl?.addForm(formClass, parent, options);
			this.$timeout(() => {
				if (this.kformCtrl && this.kformCtrl.currentClassForm in this.kformCtrl.forms) {
					this.kformCtrl.forms[this.kformCtrl.currentClassForm].modified = true;
					this.kformCtrl.forms[this.kformCtrl.currentClassForm].formio.kformForm.$setDirty();
				}
			});
		}
		await this.refresh();
	}

	/**
	 * @param {File} file
	 */
	async addFile(file) {
		const isa = await this.$uibModal.open({
			...selectIsaModalComponent({
				resolve: {
					descendants: () => this.descendants,
				},
			}),
		}).result;
		await this.add(isa, file);
	}

	/**
	 * @param {any} c
	 * @returns {any[]}
	 */
	contextMenuHandler(c) {
		/** @type {any} */
		const data = c.getData();
		const field = c.getField();

		/** @type {any[]} */
		const menu = [];

		if (this.disabled) {
			menu.push({
				label:  '<i class="fa fa-external-link"></i> Visualiser le formulaire',
				action: (_error, form) => {
					return this.kformCtrl.openForm(form.kid, this.options.parent);
				},
			});
		}
		if (this.options?.actions?.delete && !this.disabled) {
			menu.push({
				label:  '<i class="fa fa-edit"></i> Éditer le formulaire',
				action: (_error, form) => {
					return this.kformCtrl.openForm(form.kid, this.options.parent);
				},
			});
		}

		let firstSeparator = false;

		if (data?.[field]?.[0]?.file === 1) {
			if (firstSeparator) {
				menu.push({ separator: true });
			}
			menu.push({
				label:  `<i class="fa fa-download"></i> ${this.$translate.instant('common.download')}`,
				action: (error, /** @type {import('tabulator-tables').CellComponent} */ cell) => {
					/** @type {any} */
					const cellData = cell.getData();

					/** @type {string} */
					const cellField = cell.getField();

					return this.download(cellData[cellField]);
				},
			});
		}

		if (this.options?.actions?.delete && !this.disabled) {
			if (firstSeparator) {
				menu.push({ separator: true });
			}
			menu.push({
				label:  '<i class="fa fa-trash"></i> Supprimer la ligne',
				action: (error, cell) => this.delete(cell.getRow()),
			});
		}

		const extras = this.widgetActions ?? [];

		if (extras.length > 0) {
			if (firstSeparator) {
				menu.push({ separator: true });
			}
			menu.push(...extras);
		}

		return menu;
	}

	/**
	 * @param {import('~/scripts/services/model/form').default} form
	 * @param {MouseEvent} event
	 */
	// eslint-disable-next-line consistent-return
	async delete(form, event) {
		event.preventDefault();
		event.stopPropagation();

		const modal = new ConfirmDeleteModal(this.$injector);
		const answer = await modal.open(form.name);

		if (answer) {
			if (this.kformCtrl && form.kid in this.kformCtrl.forms && this.kformCtrl.forms[form.kid].create) {
				this.kformCtrl.recursiveDeleteForm(form.kid);
			}
			else {
				await this.NodeService.delete(form.kid);
				this.Notification.success({
					title:   this.$translate.instant('object.successfully-deleted-title'),
					message: this.$translate.instant('object.successfully-deleted-message'),
				});
			}
			this.ngModelCtrl?.$validate();
			await this.refresh();
		}
	}

	/**
	 * Download items
	 *
	 * @param {any[]} items
	 * @returns {Promise<void>}
	 */
	async download(items) {
		const result = await this.FileDownloadService.download(items);
		if (result) {
			Utils.download(result.data, result.data.type, result.name);
		}
	}

	/**
	 * @param {import('~/scripts/services/model/form').default} form
	 * @returns {Promise<any>}
	 */
	edit(form) {
		return this.kformCtrl?.openForm(form.kid, _.cloneDeep(this.options.parent));
	}

	getImage(form) {
		if (form.kid in this.kformCtrl.files && this.kformCtrl.files[form.kid].length > 0) {
			return this.kformCtrl.files[form.kid][0].previewData;
		}
		if (!(form instanceof Form) && form.thumb) {
			return form.thumb;
		}
	}

	getPath() {
		return this.component?.kdata?.path ?? [];
	}

	/**
	 * @param {import('@knitiv/api-client-javascript').KNode} formKid
	 * @returns {boolean}
	 */
	hasPDFFile(formKid) {
		if (formKid in this.kformCtrl.files && this.kformCtrl.files[formKid].length > 0) {
			return this.kformCtrl.files[formKid][0].file.type === 'application/pdf';
		}
		return false;
	}

	async loadDescendants() {
		this.descendants.length = 0;
		if (this.kformCtrl) {
			const form = this.kformCtrl.forms[this.kformCtrl.currentClassForm];
			if (form?.isa.objid) {
				const resultNode = await APIV5.instance.nodeInfo({
					node_kid: form.isa.objid,
					get:      {
						descendants: ['down'],
					},
				}, { id: 'card-grid.load-descendants' });
				if (resultNode?.descendants?.down) {
					this.descendants.push(...resultNode.descendants.down.filter(node => node.kid !== form.isa.objid));
				}
			}
		}
	}

	async loadItems() {
		this.items.length = 0;
		if (this.component.showLinkedItems && this.kformCtrl?.forms) {
			const form = this.kformCtrl.forms[this.kformCtrl.currentClassForm];
			if (!form.create) {
				const objects = await APIV5.instance.objectToMe({ node_kid: form.kid }, { id: 'card-grid.load-items' });
				this.items.push(...objects.nodes.map((/** @type {any} */ node) => ({
					isa:            {
						kid:     node.isa,
						objname: node.isa_name,
					},
					kid:            node.kid,
					name:           node.name,
					repre:          [
						new Repre({
							value: node.name,
						})
					],
					thumb_icon:     node.thumb_icon,
					thumb_mimetype: node.thumb_mimetype,
				})));
			}
		}
		if (this.kformCtrl?.forms) {
			this.items.push(...Object.values(this.kformCtrl.forms).filter(
				form => {
					let isVisible = form.parent
						&& form.parent.kid === this.kformCtrl.currentClassForm
						&& form.parent.key === this.component?.key;
					if (this.search) {
						const formName = ul(form.getName() ?? '');
						const formIsaName = ul(form.isa.objname);
						const search = ul(this.search ?? '');
						if (!(formName?.contains(search) || formIsaName.contains(search))) {
							isVisible = false;
						}
					}
					return isVisible;
				},
			));
		}
	}

	async openModalSelectNode() {
		if (this.kformCtrl) {
			if (this.kformCtrl.options.readOnly) {
				await this.kformCtrl.edit();
			}

			const path = await this.getPath();
			await this.$uibModal.open({
				...mfSelectModalComponent({
					resolve: {
						items: () => this.linkToValues,
						path:  () => path,
					},
				}),
			}).result;

			if (path.length > 0) {
				await this.add(path[0].kid);
			}

			// const parent = _.merge({}, this.options.parent);
			// if (parent) {
			// 	await this.add()
			// 	// TODO type 'K_NODE;STRING' should be filled by other way
			// 	this.kformCtrl.addLinkTo(path, parent, this.component.key, 'K_NODE;STRING');
			// }
		}
	}

	/**
	 */
	async refresh() {
		this.loading = true;
		await this.loadItems();
		this.$timeout(async () => {
			this.loading = false;
		});
	}

	/** @param {import('angular').IOnChangesObject} changes */
	$onChanges(changes) {
		if (changes?.options && changes.options.currentValue) {
			this.options = {
				...this.options,
				...changes.options.currentValue,
			};
		}
	}

	$onInit() {
		// this.options = _.merge(
		// 	this.defaultOptions,
		// 	this.options || {},
		// );
		this.descendants = [...(this.options.descendants ?? [])];

		this.packet_index = 1;
		this.packet_size = this.options?.packet_size ?? Defaults.query.packetSize;

		if (
			this.kformCtrl
			&& this.component?.key
			&& this.kformCtrl.forms
			&& this.options.parent
			&& this.options.parent.kid in this.kformCtrl.forms
		) {
			this.$scope.$on(`card-grid-refresh-${this.options.parent.kid}-${this.component.key}`, (
				/** @type {Event} */ event,
				/** @type {any} */ parameters,
			) => {
				if (parameters?.script === false) {
					this.tempOptions.script = false;
				}
				this.ngModelCtrl?.$setDirty();
				return this.refresh();
			});
		}

		(async () => {
			if (this.options.actions?.insertCreate && this.descendants.length === 0) {
				await this.loadDescendants();
			}
			await this.refresh();
		})();
	}
}
